import React, { FC } from "react";

import "../../App.css";

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import starfarmLogoUri from "../../images/starfarmlogo.png";

interface INavigationProps {}

const Navigation: FC<INavigationProps> = (props) => {
  return (
    <>
      {/* Centered StarFarm logo */}
      <Box
        position="fixed"
        top={20}
        left="50%"
        style={{ transform: "translateX(-50%)" }}
        display="flex"
        alignItems="center"
        zIndex={99999}
      >
        <img
          style={{ marginRight: 8 }}
          width={35}
          height={35}
          src={starfarmLogoUri}
          alt="logo"
        />
        <Typography variant="h6" style={{ color: "white", fontFamily: "Simplifica, Arial, Helvetica, sans-serif" }}>
          StarFarm
        </Typography>
      </Box>
    </>
  );
};

export default Navigation;

